export default "__VITE_ASSET__U8sCyyHV__"